export default __webpack_public_path__ + "static/media/frame_31_delay-0.05s.b9a68b38.gif";